import { useMutation } from '@apollo/client';
import { ApprovalStatus } from 'graphql-query-contracts';
import { setSubmissionVisitorApproval } from 'graphql-queries';

interface UseSubmissionVisitorApprovalParams {
  organizationId: string | undefined;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

interface UseSubmissionVisitorApprovalResult {
  approvalLoading: boolean;
  handleApproval: (
    submissionVisitorId: string,
    status: ApprovalStatus
  ) => Promise<boolean>;
}

export function useSubmissionVisitorApproval({
  organizationId,
  onSuccess,
  onError,
}: UseSubmissionVisitorApprovalParams): UseSubmissionVisitorApprovalResult {
  const [setApproval, { loading: approvalLoading }] = useMutation(
    setSubmissionVisitorApproval
  );

  const handleApproval = async (
    submissionVisitorId: string,
    status: ApprovalStatus
  ): Promise<boolean> => {
    try {
      await setApproval({
        variables: {
          input: {
            submissionVisitorId,
            approvalStatus: status,
            organizationId,
          },
        },
      });
      onSuccess?.();

      return true;
    } catch (error) {
      if (error instanceof Error) {
        onError?.(error);
      }

      return false;
    }
  };

  return {
    approvalLoading,
    handleApproval,
  };
}
